import { Row, Column } from 'gatsby-theme-carbon/src/components/Grid';
import img1 from "../../../../src/pages/toolkit/develop/keyboard/images/visible_focus.png";
import img11 from "../../../../src/visuals/develop/coding_interactions_keyboard_3_do.png";
import img12 from "../../../../src/visuals/develop/coding_interactions_keyboard_3_dont.png";
import { withPrefix } from "gatsby";
import ToolkitRequirement from "../../../../src/components/rms_resources/requirements";
import ToolkitReference from "../../../../src/components/rms_resources/references";
import ToolkitTechnique from "../../../../src/components/rms_resources/techniques";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import * as React from 'react';
export default {
  Row,
  Column,
  img1,
  img11,
  img12,
  withPrefix,
  ToolkitRequirement,
  ToolkitReference,
  ToolkitTechnique,
  ToolkitTopic,
  React
};